import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Input, Segment, Button } from 'semantic-ui-react';
import { DateTime } from 'luxon';
import { AdminState } from '../../types/admin-state';
import { AppState } from '../../types/app-state';
import {
	InitialiseManageOrganisation,
	UpdateOrganisationState,
} from '../../actions/admin.actions';
import './OrganisationStatePage.less';

export const OrganisationStatePage: React.FC = () => {
	const dispatch = useDispatch();
	const { organisations } = useSelector<AppState, Partial<AdminState>>(
		(state) => state.admin
	);
	const [filter, setFilter] = useState('');
	const filteredOrgs = (organisations?.data || []).filter((org) => {
		return (
			filter === '' ||
			(org.name || '').includes(filter) ||
			(org.tenantId || '').includes(filter)
		);
	});

	const handleFilterChange = (e: React.SyntheticEvent<HTMLInputElement>) => {
		setFilter((e.target as HTMLInputElement).value);
	};

	useEffect(() => {
		dispatch(InitialiseManageOrganisation());
	}, [dispatch]);

	return (
		<div className='organisationstate-page'>
			<h1>Manage Organisations</h1>
			<Input
				placeholder='Filter'
				autoFocus
				value={filter}
				onChange={handleFilterChange}
			/>
			<Segment loading={organisations?.isRequesting}>
				{organisations && organisations.data.length > 0 && (
					<ul>
						{filteredOrgs.length > 0 && (
							<li>
								<span>
									<b>Name</b>
								</span>
								<span>
									<b>Tenant ID</b>
								</span>
								<div />
							</li>
						)}
						{filteredOrgs.map((org) => (
							<li key={org.id}>
								<span>{org.name}</span>
								<span>{org.tenantId}</span>
								<div>
									{org.deactivatedAt ? (
										<>
											<span>
												Deactivated at:{' '}
												{DateTime.fromISO(org.deactivatedAt).toLocaleString(DateTime.DATETIME_FULL)}
											</span>
											<Button
												onClick={() =>
													dispatch(UpdateOrganisationState(org.id, false))
												}
											>
												Activate
											</Button>
										</>
									) : (
										<Button
											onClick={() =>
												dispatch(UpdateOrganisationState(org.id, true))
											}
										>
											Deactivate
										</Button>
									)}
								</div>
							</li>
						))}
						{filteredOrgs.length === 0 && <li>No item matched.</li>}
					</ul>
				)}
				{organisations?.data.length === 0 && (
					<p>There are no organisations yet</p>
				)}
			</Segment>
		</div>
	);
};

export default OrganisationStatePage;
